import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from './helper';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message: string;
}

// **Thunks**
export const integrationsSaveWorkiz = createAsyncThunk<boolean, any>(
  'integrations/integrationsSaveWorkiz',
  async (data) => {
    const response = await request('api/integrations/workiz', 'POST', data);
    return response.success;
  }
);

export const claimJobberTokens = createAsyncThunk<boolean, any>(
  'integrations/claimJobberTokens',
  async (data) => {
    const response = await request('api/integrations/jobber/claim', 'POST', {key: data});
    return response.success;
  }
);

export const disconnectJobber = createAsyncThunk<ApiResponse<any>, number>(
  'integrations/disconnectJobber',
  async (userId) => {
    const response = await request('api/integrations/jobber/disconnect', 'POST', {userId});
    return response.data;
  }
);

// **Initial State**
const initialState = {
  loading: false
};

// **Slice**
const integrationsSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Save Workiz API creds
    builder
      .addCase(integrationsSaveWorkiz.pending, (state) => {
        state.loading = true;
      })
      .addCase(integrationsSaveWorkiz.fulfilled, (state, { payload }: any) => {
        state.loading = false;
      })
      .addCase(integrationsSaveWorkiz.rejected, (state) => {
        state.loading = false;
      })
    
      builder
      .addCase(claimJobberTokens.pending, (state) => {
        state.loading = true;
      })
      .addCase(claimJobberTokens.fulfilled, (state, { payload }: any) => {
        state.loading = false;
      })
      .addCase(claimJobberTokens.rejected, (state) => {
        state.loading = false;
      })
      
      builder
      .addCase(disconnectJobber.pending, (state) => {
        state.loading = true;
      })
      .addCase(disconnectJobber.fulfilled, (state, { payload }: any) => {
        state.loading = false;
      })
      .addCase(disconnectJobber.rejected, (state) => {
        state.loading = false;
      });
  },
});

// **Export Reducer**
export default integrationsSlice.reducer;